// extracted by mini-css-extract-plugin
export default {"ComponentMenu":"ComponentMenu_ComponentMenu__qvzCC"};